exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".distance-space{margin-left:0px !important;margin-right:0px !important}.opacity{opacity:0.5}\n", ""]);

// exports
